import { render } from "./AllNews.vue?vue&type=template&id=6b271ec6&scoped=true"
import script from "./AllNews.vue?vue&type=script&lang=js"
export * from "./AllNews.vue?vue&type=script&lang=js"

import "./AllNews.vue?vue&type=style&index=0&id=6b271ec6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b271ec6"]])

export default __exports__